module.exports = __webpack_public_path__ + "static/img_0981-5b7c39562d1a8920df2970e0a66aaaa8.webp";